export const ApplicationConstant = {
    ApplicationID : 10,
    clientId : 7,
    organizationId: 7,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 11
}